import uniqBy from "lodash/uniqBy";
import cloneDeep from "lodash/cloneDeep";
import {runAction} from "./actions";

export const systemMessage = (store, data) => {
  let prevMsgs = uniqBy(store.state.notification.msgs, 'created_time');
  let nextMsgs = uniqBy([...cloneDeep(store.state.notification.msgs), ...cloneDeep(data)], 'created_time');
  if (prevMsgs.length === nextMsgs.length) return;
  runAction(store, data)
}
